var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-group",class:_vm.fgClass},[_c('label',[_vm._v(_vm._s(_vm.labelText)),(_vm.required)?_c('i',{staticClass:"form-sign-attribute-required"},[_vm._v("*")]):_vm._e()]),_vm._t("default"),_c('error-help-block',{attrs:{"message":_vm.errorMessage}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }